import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';
import * as imageConversion from 'image-conversion';

declare var EXIF: any;

@Injectable({
  providedIn: 'root'
})
export class SharedUtilService {

  constructor(private snackBar: MatSnackBar) {}


  isSmallScreen() {
    return window.innerWidth <= 576;
  }

  public static isPC() {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  public getSystem() {
    //return 'windows';
    //return 'mac';
    if (SharedUtilService.isPC()) {
      const os = (<any>window).nodeRequire('os');
      if (os.platform() === 'darwin') {
        return 'mac';
      } else if (os.platform() === 'win32') {
        return 'windows';
      }
    }
    return 'cordova';
  }

  public debounce(func, wait = 500, immediate = true) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate)
          func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  public getFileExt(filename: any): string {
    const fileName = filename.toString();
    const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return fileExtension.toString().toLowerCase();
  }

  public startWith(str, beginStr) {
    if (str.substr(0, beginStr.length) === beginStr) {
      return true;
    }
    return false;
  }

  public compressImage(file, callback) {
    let img = new Image();
    let objectUrl = URL.createObjectURL(file);
  
    img.onload = () => {
      let imageMaxWidth: number = img.width > img.height ? img.width : img.height;
      let imageScale: number = 1;
      if (imageMaxWidth > 2 * 1024) {
        imageScale = 2 * 1024 / imageMaxWidth;
      }
  
      let _compressSize = 200;  // default
      if (imageScale < 1 && file.size < 200 * 1024) {
        _compressSize = file.size / 1024 * 0.9;  //active the small image to compress if the original size is big.
      }
  
      imageConversion.compressAccurately(file, {
        size: _compressSize,    //The compressed image size is 200kb
        scale: imageScale,
      })
      .then((compressedFile) => {
        console.log('image size is:' + _compressSize + ' : ' +imageScale + ' ' + compressedFile.size / 1024 + 'KB');
        callback(compressedFile);
        img.onload = null; // Free up memory used by the event handler
        img.src = ''; // Free up memory used by the image data
        img = null; // Allow the Image object to be garbage collected
        URL.revokeObjectURL(objectUrl); // Revoke the Blob URL as soon as we're done with it
      })
    };
  
    img.src = objectUrl;
  }

  public dateFtt(fmt, date) {
    var o = {
      "M+": date.getMonth() + 1,                 //月份
      "d+": date.getDate(),                    //日
      "h+": date.getHours(),                   //小时
      "m+": date.getMinutes(),                 //分
      "s+": date.getSeconds(),                 //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }

  //**dataURL to blob**
  public dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  
  //**blob to dataURL**
  public blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function (e: any) { callback(e.target.result); }
    a.readAsDataURL(blob);
  }

  //test:
//var blob = dataURLtoBlob('data:text/plain;base64,YWFhYWFhYQ==');
//blobToDataURL(blob, function (dataurl) {
// console.log(dataurl);
//});
  showSnackBar(message) {
    let config = new MatSnackBarConfig();
    // config.verticalPosition = 'top';
    config.duration = 3000;
    this.snackBar.open(message, 'OK', config)
  }

  // TODO compare file With indexedDB file data
  public checkSameBlobFile(file, blob_file) {
    if (!file || !blob_file) return false;
    if (typeof (file) == 'undefined' || typeof (blob_file) == 'undefined') return false;
    if (typeof (file.lastModified) == 'undefined' || typeof (blob_file.lastModified) == 'undefined') return false;
    if (typeof (file.name) == 'undefined' || typeof (blob_file.name) == 'undefined') return false;
    let fileSize = file.size;
    if(fileSize == null) {
      fileSize = 0;
    }
    let blob_fileSize = blob_file.size;
    if(blob_fileSize == null) {
      blob_fileSize = 0;
    }
    // if (typeof (file.size) == 'undefined' || typeof (blob_file.size) == 'undefined') return false;

    if (fileSize === blob_fileSize) {
      if (file.name === blob_file.name) {
        if (file.lastModified === blob_file.lastModified) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public sanitizeS3Key(s3Key) {
    const sanitizedS3Key = s3Key.replace(/[*]/g, '_');
    return sanitizedS3Key;
  }
}
